import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrHistoryIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M9.7 9.2C9.8 9.7 9.8 10.2 9.7 10.7C9.5 11.2 9.2 11.6 8.8 12C8.4 12.3 7.9 12.5 7.4 12.6C6.9 12.6 6.4 12.5 5.9 12.3C5.4 12 5.2 11.7 4.9 11.3C4.8 11.1 4.8 10.8 5.1 10.6C5.3 10.5 5.6 10.5 5.8 10.8C6 11.1 6.1 11.3 6.4 11.4C6.7 11.6 7 11.6 7.3 11.6C7.6 11.6 7.9 11.5 8.2 11.2C8.5 10.9 8.6 10.7 8.7 10.4C8.8 10.1 8.8 9.8 8.7 9.4C8.6 9.1 8.5 8.9 8.2 8.6C8 8.4 7.7 8.3 7.3 8.3C7.2 8.3 7 8.3 6.9 8.3C7.1 8.3 7.3 8.5 7.3 8.7C7.3 9 7.1 9.2 6.8 9.2L5.3 9.4C5.1 9.4 5 9.3 4.9 9.2C4.8 9.1 4.7 8.9 4.8 8.7L5.2 7.2C5.3 6.9 5.5 6.8 5.8 6.8C6.1 6.9 6.2 7.1 6.2 7.4C6.6 7.2 7.1 7.2 7.5 7.2C8 7.3 8.5 7.5 8.9 7.8C9.2 8.2 9.5 8.7 9.7 9.2ZM14.4 1.7V11.3C14.4 12.2 13.6 13 12.7 13H12.1V13.6C12.1 14.5 11.3 15.3 10.4 15.3H3.7C2.8 15.3 2 14.5 2 13.6V4C2 3.1 2.8 2.3 3.7 2.3H4.3V1.7C4.3 0.8 5.1 0 6 0H12.7C13.6 0 14.4 0.8 14.4 1.7ZM10.7 4C10.7 3.8 10.6 3.7 10.4 3.7H3.7C3.5 3.7 3.4 3.8 3.4 4V13.6C3.4 13.8 3.5 13.9 3.7 13.9H10.4C10.6 13.9 10.7 13.8 10.7 13.6V4ZM13 1.7C13 1.5 12.9 1.4 12.7 1.4H6C5.8 1.4 5.7 1.5 5.7 1.7V2.3H10.4C11.3 2.3 12.1 3.1 12.1 4V11.6H12.7C12.9 11.6 13 11.5 13 11.3V1.7Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrHistoryIconComponent;
